module.exports = __webpack_public_path__ + "static/media/product-original.3c82c49f.png";